module.exports = __webpack_public_path__ + "static/img/logo.689a6d98.svg";